import { render } from "./DocumentScrapingPanel.vue?vue&type=template&id=20119048&scoped=true"
import script from "./DocumentScrapingPanel.vue?vue&type=script&lang=js"
export * from "./DocumentScrapingPanel.vue?vue&type=script&lang=js"

import "./DocumentScrapingPanel.vue?vue&type=style&index=0&id=20119048&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20119048"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSelect,QFile,QBtn,QInput});
